import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {MatDialog} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-recap-kpi',
    templateUrl: './recap-kpi.component.html',
    styleUrls: ['./recap-kpi.component.scss']
})
export class RecapKpiComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    user: User = Object.assign({}, EMPTY_USER);

    constructor(public cityService: CityService,
                public adService: AdService,
                public commonService: CommonService,
                public authenticationService: AuthenticationService,
                public dialog: MatDialog) {
    }

    ngOnInit() {
        this.user = this.authenticationService.currentUser;
    }
}
